import {axiosGet, urlGenerator} from "../../../common/Helper/AxiosHelper";
import {TENANT_BASE_URL} from "../../../common/Config/UrlHelper";
import DatatableHelperMixin from "../../../common/Mixin/Global/DatatableHelperMixin";
import {formatDateToLocal} from "../../../common/Helper/Support/DateTimeHelper";

export default {
    mixins: [DatatableHelperMixin],
    data() {
        const urlParams = new URLSearchParams(location.search);
        const workPlaceFilterInitValue = urlParams.get('work_place_id') || null;

        const getTranslate = (row) => {
            const locate = window?.appLanguage.toLowerCase()

            if (row[locate] && row[locate] !== '') {
                return row[locate]
            }

            return row['ja'] || ''
        }
        return {
            urlGenerator,
            options: {
                name             : this.$t('candidate'),
                url              : `${TENANT_BASE_URL}app/candidate`,
                showCount        : true,
                showClearFilter  : true,
                showHeader       : true,
                tableShadow      : false,
                tablePaddingClass: 'pt-primary',
                cardViewComponent: 'app-candidate-card-view',
                columns          : [
                    {
                        title    : this.$t('actions'),
                        type     : 'action',
                        key      : 'id',
                        isVisible: true
                    },
                    {
                        title    : this.$t('profile'),
                        type     : 'custom-html',
                        key      : 'image',
                        isVisible: true,
                        modifier : (value, row) => {
                            let html        = ''
                            let titleFilter = (str) => {
                                str            = str.replace(/(^\s*)|(\s*$)/gi, "");
                                str            = str.replace(/[ ]{2,}/gi, " ");
                                str            = str.replace(/\n /, "\n");
                                let titleArray = str.split(' ');
                                if (titleArray.length > 1) {
                                    return (titleArray[0][0] + titleArray[1][0]).toLocaleUpperCase();
                                } else {
                                    return titleArray[0].substring(0, 2).toLocaleUpperCase();
                                }
                            }

                            html += '<div class="media align-items-center">'
                            html += '   <div class="avatars-w-50">'
                            if (row.avatar) {
                                html += '<img class="rounded-circle" src="' + row.avatar + '" alt="">'
                            } else {
                                html += '<div class="no-img rounded-circle">' + titleFilter(row.name_romaji) + '</div>'
                            }
                            html += '   </div>'
                            html += '   <div class="media-body ml-3">'
                            html += '       <a href="javascript:void(0)">' + row.name_romaji + '</a>'
                            html += '       <a href="javascript:void(0)">' + row.name_katakana + '</a>'
                            html += '       <p class="text-muted font-size-90 mb-0">' + row.email + '</p>'
                            html += '       <p class="text-muted font-size-90 mb-0">' + row.phone + '</p>'
                            html += '       <p class="text-muted font-size-90 mb-0">' + row.recruitment_text + '</p>'
                            html += '   </div>'
                            html += '</div>'

                            return html;
                        }
                    },
                    {
                        title    : this.$t('work_place'),
                        type     : 'custom-html',
                        key      : 'work_place',
                        isVisible: true,
                        modifier : (value) => getTranslate(value)
                    },
                    {
                        title    : this.$t('tags'),
                        type     : 'custom-html',
                        key      : 'tags',
                        isVisible: true,
                        modifier : (value) => {
                            let result = '<div class="tag-container">';
                            for (const tag of value) {
                                result += '<div class="tag-item badge badge-pill badge-primary">' + tag.title + '</div>';
                            }
                            return result + '</div>';
                        }
                    },
                    {
                        title    : this.$t('residence'),
                        type     : 'text',
                        key      : 'residence_text',
                        isVisible: true,
                    },
                    {
                        title    : this.$t('clothing_size'),
                        type     : 'text',
                        key      : 'clothing_size_text',
                        isVisible: true,
                    },
                    {
                        title    : this.$t('years_in_japan'),
                        type     : 'text',
                        key      : 'in_japan',
                        isVisible: true,
                    },
                    {
                        title    : this.$t('experience'),
                        type     : 'custom-html',
                        key      : 'experience',
                        isVisible: true,
                        modifier : (value) => {
                            return value === 1 ? this.$t('Yes') : this.$t('No');
                        }
                    },
                    {
                        title    : this.$t('start_date'),
                        type     : 'custom-html',
                        key      : 'start',
                        isVisible: true,
                        modifier : (value) => {
                            return formatDateToLocal(value);
                        }
                    },
                    {
                        title    : this.$t('station'),
                        type     : 'text',
                        key      : 'station',
                        isVisible: true,
                    },
                    {
                        title    : this.$t('commuting_time'),
                        type     : 'text',
                        key      : 'how_long',
                        isVisible: true,
                    },
                    {
                        title    : this.$t('monday'),
                        type     : 'text',
                        key      : 'monday_text',
                        isVisible: true,
                    },
                    {
                        title    : this.$t('tuesday'),
                        type     : 'text',
                        key      : 'tuesday_text',
                        isVisible: true,
                    },
                    {
                        title    : this.$t('wednesday'),
                        type     : 'text',
                        key      : 'wednesday_text',
                        isVisible: true,
                    },
                    {
                        title    : this.$t('thursday'),
                        type     : 'text',
                        key      : 'thursday_text',
                        isVisible: true,
                    },
                    {
                        title    : this.$t('friday'),
                        type     : 'text',
                        key      : 'friday_text',
                        isVisible: true,
                    },
                    {
                        title    : this.$t('saturday'),
                        type     : 'text',
                        key      : 'saturday_text',
                        isVisible: true,
                    },
                    {
                        title    : this.$t('sunday'),
                        type     : 'text',
                        key      : 'sunday_text',
                        isVisible: true,
                    },
                    {
                        title    : this.$t('recruitment'),
                        type     : 'text',
                        key      : 'recruitment_text',
                        isVisible: true,
                    },
                    {
                        title    : this.$t('job_broker'),
                        type     : 'text',
                        key      : 'job_broker',
                        isVisible: true,
                    },
                    {
                        title    : this.$t('remark'),
                        type     : 'textarea',
                        key      : 'remark',
                        isVisible: true,
                    },
                ],
                filters          : [
                    {
                        title         : this.$t('work_place'),
                        type          : "multi-select-filter",
                        key           : "work_place_id",
                        option        : [],
                        listValueField: 'title',
                        initValue     : workPlaceFilterInitValue,
                    },
                    {
                        title         : this.$t('residence'),
                        type          : "multi-select-filter",
                        key           : "residence",
                        option        : [],
                        listValueField: 'name',
                    },
                    {
                        title     : this.$t('gender'),
                        type      : "checkbox",
                        key       : "gender",
                        option    : [
                            {id: 'male', value: this.$t('male')},
                            {id: 'female', value: this.$t('female')},
                            {id: 'other', value: this.$t('other')}
                        ],
                        permission: !!this.$can('view_employees')
                    },
                    {
                        title         : this.$t('tags'),
                        type          : "multi-select-filter",
                        key           : "tag_id",
                        option        : [],
                        listValueField: 'title',
                        permission    : !!this.$can('view_interview_tag')
                    },
                    {
                        title         : this.$t('recruitment'),
                        type          : "multi-select-filter",
                        key           : "recruitment",
                        option        : [],
                        listValueField: 'name',
                    },
                ],
                paginationType   : "pagination",
                responsive       : true,
                rowLimit         : 10,
                showAction       : true,
                orderBy          : 'desc',
                actionType       : 'dropdown',
                actions          : [
                    {
                        title   : this.$t('convert'),
                        icon    : 'corner-up-right',
                        type    : 'modal',
                        modifier: row => this.$can('update_candidate')
                    },
                    {
                        title   : this.$t('view'),
                        icon    : 'eye',
                        type    : 'modal',
                        modifier: row => this.$can('view_candidate')
                    },
                    {
                        title   : this.$t('send_email'),
                        icon    : 'send',
                        type    : 'modal',
                        modifier: row => this.$can('view_candidate')
                    },
                    {
                        title   : this.$t('edit'),
                        icon    : 'edit',
                        type    : 'modal',
                        modifier: row => this.$can('update_candidate')
                    },
                    {
                        title    : this.$t('delete'),
                        icon     : 'trash-2',
                        type     : 'modal',
                        component: 'app-confirmation-modal',
                        modalId  : 'app-confirmation-modal',
                        url      : `${TENANT_BASE_URL}app/candidate`,
                        name     : 'delete',
                        modifier : row => this.$can('delete_candidate')
                    }
                ],
            }
        }
    },
    mounted() {
        this.getFilterOptions();
    },
    methods: {
        getFilterOptions() {
            const Error             = error => this.$toastr.e(error.response.data.message)
            const workPlaceFilter   = this.options.filters.find(item => item.key === 'work_place_id');
            const residenceFilter   = this.options.filters.find(item => item.key === 'residence');
            const tagFilter         = this.options.filters.find(item => item.key === 'tag_id');
            const recruitmentFilter = this.options.filters.find(item => item.key === 'recruitment');
            const locate            = window?.appLanguage.toLowerCase();

            axiosGet(`${TENANT_BASE_URL}api/candidate/residence`).then(({data}) => residenceFilter.option = data).catch(Error)
            axiosGet(`${TENANT_BASE_URL}api/candidate/recruitment?locale=${locate}`).then(({data}) => recruitmentFilter.option = data).catch(Error)
            axiosGet(`${TENANT_BASE_URL}api/work-place?per_page=0&locate=${locate}`).then(({data}) => workPlaceFilter.option = data).catch(Error)
            axiosGet(`${TENANT_BASE_URL}app/interview-tag?per_page=0&type=0,2`).then(({data}) => tagFilter.option = data).catch(Error)
        },
    },
}
